import { render, staticRenderFns } from "./NewViolation.vue?vue&type=template&id=6e688ee8"
import script from "./NewViolation.vue?vue&type=script&lang=js"
export * from "./NewViolation.vue?vue&type=script&lang=js"
import style0 from "./NewViolation.vue?vue&type=style&index=0&id=6e688ee8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports